// ENRICHMENT ANSWER TYPES

export const ENRICHMENT_ANSWER_TYPE_EMAIL = 'email',
    ENRICHMENT_ANSWER_TYPE_URL = 'link',
    ENRICHMENT_ANSWER_TYPE_PHONE = 'phone',
    ENRICHMENT_ANSWER_TYPE_TEXT = 'text',
    ENRICHMENT_ANSWER_TYPE_NUMBER = 'numeric',
    ENRICHMENT_ANSWER_TYPE_OPTIONS = 'options',
    ENRICHMENT_ANSWER_TYPE_RATING = 'rating'